import { Menu } from "antd";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import getPermissions from "../../utils/getPermissions";
import store from "../../assets/images/store.svg"
import promoicon from "../../assets/images/discount.svg"
import gameCard from "../../assets/images/card-game.svg"
import slot from "../../assets/images/timeslots-regular.svg"
import booking from "../../assets/images/booking.svg"

export default function SideBar({ onNavigate }) {
  const permissions = getPermissions();
  const location = useLocation();
  
  const hasPermission = (item) => {
    return permissions?.includes(item ? item : "");
  };

  // Get current active menu key based on path
  const getSelectedKey = () => {
    const path = location.pathname;
    if (path.includes('/admin/franchises') || path.includes('/admin/franchise/update') || path.includes('/admin/franchise/create')) return 'franchiseManage';
    if (path.includes('/admin/games')) return 'games';
    if (path.includes('/admin/slot')) return 'slot';
    if (path.includes('/admin/promocode')) return 'promocode';
    if (path.includes('/admin/booking')) return 'booking';
    return '';
  };

  const handleNavClick = () => {
    if (onNavigate) {
      onNavigate();
    }
  };

  const menu = [
    (hasPermission("create-user") ||
      hasPermission("readAll-user") ||
      hasPermission("readAll-role") ||
      hasPermission("readAll-designation") ||
      hasPermission("readAll-department")) && {
      label: "Franchise Manage",
      key: "franchiseManage",
      label: (
        <NavLink to='/admin/franchises' onClick={handleNavClick} className={({ isActive }) => `flex items-center gap-3 pt-2 mb-1 ${isActive ? 'text-primary' : ''}`}>
          <span><img src={store} className="w-[20px]"/></span>
          <span>All Franchise</span>
        </NavLink>
      ),
    },
    (hasPermission("readAll-games") ||
      hasPermission("readSingle-product") ||
      hasPermission("create-games")) && {
      label: (
        <NavLink to='/admin/games' onClick={handleNavClick} className={({ isActive }) => `flex items-center gap-3 pt-2 mb-1 ${isActive ? 'text-primary' : ''}`}>
          <span><img src={gameCard} className="w-[20px]"/></span>
          <span>All Games</span>
        </NavLink>
      ),
      key: "games",
    },
    // (hasPermission("readAll-crmTask") ||
    //   hasPermission("readSingle-crmTask") ||
    //   hasPermission("create-crmTask")) && {
    //   label: (
    //     <NavLink to='/admin/slot' className={({ isActive }) => `flex items-center gap-3 pt-2 ${isActive ? 'text-primary' : ''}`}>
    //       <span><img src={slot} className="w-[20px]"/></span>
    //       <span>All Slots</span>
    //     </NavLink>
    //   ),
    //   key: "slot",
    // },
    (hasPermission("readAll-quote") ||
      hasPermission("readSingle-quote") ||
      hasPermission("create-quote")) && {
      label: (
        <NavLink to='/admin/promocode' onClick={handleNavClick} className={({ isActive }) => `flex items-center gap-3  mb-1 ${isActive ? 'text-primary' : ''}`}>
          <span><img src={promoicon} className="w-[20px]"/></span>
          <span>All Promocode</span>
        </NavLink>
      ),
      key: "promocode",
    },
    (hasPermission("readAll-quote") ||
      hasPermission("readSingle-quote") ||
      hasPermission("create-quote")) && {
      label: (
        <NavLink to='/admin/booking' onClick={handleNavClick} className={({ isActive }) => `flex items-center gap-3 pt-2 mb-1 ${isActive ? 'text-primary' : ''}`}>
          <span><img src={booking} className="w-[20px]"/></span>
          <span>All Booking</span>
        </NavLink>
      ),
      key: "booking",
    }
  ];

  return (
    <>
      <div className='select-none sidebar-menu'>
        <Menu
          className='bg-white text-[#161A1D] border-none font-poppins pt-2'
          mode='inline'
          items={menu}
          selectedKeys={[getSelectedKey()]}
          onClick={handleNavClick}
          triggerSubMenuAction="click"
          builtinPlacements={{}}
        />
      </div>
    </>
  );
}
